import React, { useEffect, useState } from "react";
import "./App.css";
import moonIcon from "./assets/images/icon-moon.svg";
import sunIcon from "./assets/images/icon-sun.svg";
import Form from "./Components/Form";
import TodoList from "./Components/TodoList";

const App = () => {
  const [todos, setTodos] = useState(savedTodos());
  const [input, setInput] = useState("");
  const [filter, setFilter] = useState("all");

  // initialize theme state from local storage or default light
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved === null ? false : saved === "true";
  });

  // update body class whenever theme icon is clicked
  useEffect(() => {
    document.body.classList.toggle("darkmode", darkMode);
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // function to change toggle theme
  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
  };

  function handleSubmit(e) {
    e.preventDefault();
    if (!input.trim()) {
      alert("provide a task");
      return;
    }
    setTodos([...todos, { task: input, completed: false }]);
    setInput("");
  }

  // add todo item logic

  function savedTodos() {
    let data = localStorage.getItem("todos");
    let json = JSON.parse(data);

    if (json) {
      return json;
    }
    return [];
  }

  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  function handleInput(e) {
    // let task = e.target.value;
    setInput(e.target.value);
  }

  // function to delete todos

  const deleteTodos = (index) => {
    setTodos((current) => current.filter((_, i) => i !== index));
  };

  // mark as completed function

  const toggleCompleted = (index) => {
    setTodos((prev) =>
      prev.map((todo, i) =>
        i === index ? { ...todo, completed: !todo.completed } : todo,
      ),
    );
  };

  // filter logic
  const filteredTodos = todos.filter((todo) => {
    if (filter === "completed") return todo.completed;
    if (filter === "uncompleted") return !todo.completed;
    return true;
  });

  // clear completed functionality
  const clearCompleted = () => {
    setTodos((current) => current.filter((todo) => !todo.completed));
  };

  return (
    <div className="container">
      <div className="header">
        <h1 className="title">Todo</h1>
        <img
          className="moon"
          src={darkMode ? sunIcon : moonIcon}
          alt="theme-icon"
          onClick={toggleTheme}
        />
      </div>
      <Form
        input={input}
        handleInput={handleInput}
        handleSubmit={handleSubmit}
      />
      <TodoList
        todos={filteredTodos}
        deleteTodos={deleteTodos}
        toggleCompleted={toggleCompleted}
        clearCompleted={clearCompleted}
        filter={filter}
        setFilter={setFilter}
      />
    </div>
  );
};

export default App;
